import { render } from "./index.vue?vue&type=template&id=a5058dc0"
import script from "./component.js?vue&type=script&lang=js"
export * from "./component.js?vue&type=script&lang=js"

import "./style.sass?vue&type=style&index=0&lang=sass"
script.render = render

export default script